import { version } from "../../../package.json";

// склонение слова билет
export const getTicketWord = (amount) => {
  const lastDigit = amount % 10;
  const lastTwoDigits = amount % 100;

  if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
    return "билетов";
  }

  if (lastDigit === 1) {
    return "билет";
  }

  if (lastDigit >= 2 && lastDigit <= 4) {
    return "билета";
  }

  return "билетов";
};

/**
 * Форматирует секунды в строку формата HH:MM:SS
 * @param {number} seconds - количество секунд
 * @returns {string} отформатированное время в формате HH:MM:SS
 */
export const formatTime = (seconds) => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  // Добавляем ведущие нули
  const pad = (num) => (num < 10 ? `0${num}` : num);

  return `${pad(hours)}:${pad(minutes)}:${pad(secs)}`;
};

export const checkVersion = () => {
  const storedVersion = localStorage.getItem("app_version");

  // Если версии нет или она отличается от текущей
  if (!storedVersion || storedVersion !== version) {
    // Очищаем кэш
    if ("caches" in window) {
      caches.keys().then((cacheNames) => {
        cacheNames.forEach((cacheName) => {
          caches.delete(cacheName);
        });
      });
    }

    // Обновляем версию в localStorage
    localStorage.setItem("app_version", version);

    // Перезагружаем страницу
    window.location.reload(true);
  }
};
